/* ============================================================
 * Brindle UK · Advertorial landing — page script
 * Loaded conditionally from layout/theme.liquid (template == page.brindle-adv).
 * IIFE + global guard. No external deps.
 * ============================================================ */
(function () {
  'use strict';
  if (window.__brindleAdvLoaded) return;
  window.__brindleAdvLoaded = true;

  /* ---------- Reduced motion pauses the marquee ---------- */
  function respectReducedMotion() {
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!mq) return;
    var apply = function () {
      document.querySelectorAll('.bra-marquee__track').forEach(function (track) {
        track.style.animationPlayState = mq.matches ? 'paused' : 'running';
      });
    };
    apply();
    try { mq.addEventListener('change', apply); }
    catch (e) { if (mq.addListener) mq.addListener(apply); }
  }

  /* ---------- Pause marquee animation when tab is hidden (perf) ---------- */
  function pauseMarqueeOnHidden() {
    document.addEventListener('visibilitychange', function () {
      var state = document.hidden ? 'paused' : 'running';
      document.querySelectorAll('.bra-marquee__track').forEach(function (track) {
        // Don't override the reduced-motion pause
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          track.style.animationPlayState = state;
        }
      });
    });
  }

  /* ---------- Smooth-scroll fallback for older browsers ---------- */
  function smoothScrollHashLinks() {
    if ('scrollBehavior' in document.documentElement.style) return; // native
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var hash = a.getAttribute('href');
      if (!hash || hash === '#') return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* ---------- Header cart count refresh (best-effort) ----------
     If a .bra-header__cart with [data-cart-count] exists we
     refresh it from /cart.js on load. Silent on failure. */
  function refreshCartCount() {
    var nodes = document.querySelectorAll('[data-bra-cart-count]');
    if (!nodes.length || typeof fetch !== 'function') return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        nodes.forEach(function (n) { n.textContent = cart.item_count; });
      })
      .catch(function () {/* silent */});
  }

  function init() {
    respectReducedMotion();
    pauseMarqueeOnHidden();
    smoothScrollHashLinks();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
